import { render, staticRenderFns } from "./DeleteLinkAlert.vue?vue&type=template&id=4ff6d156"
import script from "./DeleteLinkAlert.vue?vue&type=script&lang=js"
export * from "./DeleteLinkAlert.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports